(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-brand-grid-full"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pf-bgf__az-nav').forEach(function (navEl) {
    var sid = navEl.id.replace('pf-bgf-az-', '');
    var sectionsEl = document.getElementById('pf-bgf-sections-' + sid);
    var emptyEl    = document.getElementById('pf-bgf-empty-'    + sid);
    var searchEl   = document.getElementById('pf-bgf-search-'   + sid);

    /* Offset sticky nav below the site header */
    var header = document.getElementById('pf-header');
    function setNavTop() {
      if (header) navEl.style.top = header.offsetHeight + 'px';
    }
    setNavTop();
    window.addEventListener('resize', setNavTop);

    /* Set scroll-margin-top on each letter section to match nav height */
    function setScrollMargins() {
      var navH = (header ? header.offsetHeight : 0) + navEl.offsetHeight;
      if (sectionsEl) {
        sectionsEl.querySelectorAll('.pf-bgf__letter-section').forEach(function (s) {
          s.style.scrollMarginTop = (navH + 8) + 'px';
        });
      }
    }
    setScrollMargins();
    window.addEventListener('resize', setScrollMargins);

    /* A-Z nav click → scroll to section */
    navEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.pf-bgf__az-btn');
      if (!btn || btn.disabled) return;
      var target = document.getElementById(btn.dataset.azTarget);
      if (!target) return;
      var navH  = (header ? header.offsetHeight : 0) + navEl.offsetHeight + 8;
      var top   = window.scrollY + target.getBoundingClientRect().top - navH;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });

    /* Highlight active letter via IntersectionObserver */
    if (sectionsEl && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var letter = entry.target.dataset.letter;
          navEl.querySelectorAll('.pf-bgf__az-btn').forEach(function (b) {
            b.classList.toggle('pf-bgf__az-btn--active', b.textContent.trim() === letter);
          });
        });
      }, { rootMargin: '-15% 0px -75% 0px', threshold: 0 });
      sectionsEl.querySelectorAll('.pf-bgf__letter-section').forEach(function (s) { obs.observe(s); });
    }

    /* Search */
    if (searchEl && sectionsEl) {
      searchEl.addEventListener('input', function () {
        var q = searchEl.value.trim().toLowerCase();
        var hasQ = q.length > 0;
        navEl.hidden = hasQ;

        var totalVisible = 0;
        sectionsEl.querySelectorAll('.pf-bgf__letter-section').forEach(function (sec) {
          var sectionVisible = 0;
          sec.querySelectorAll('.pf-bgf__item').forEach(function (item) {
            var match = !hasQ || (item.dataset.name || '').indexOf(q) !== -1;
            item.hidden = !match;
            if (match) sectionVisible++;
          });
          sec.hidden = sectionVisible === 0;
          totalVisible += sectionVisible;
        });

        if (emptyEl) emptyEl.hidden = totalVisible > 0 || !hasQ;
      });
    }
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-brand-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.pf-bg__search-input').forEach(function (input) {
    var sid = input.id.replace('pf-bg-search-', '');
    var grid = document.getElementById('pf-bg-grid-' + sid);
    var empty = document.getElementById('pf-bg-empty-' + sid);
    if (!grid) return;

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var items = grid.querySelectorAll('.pf-bg__item');
      var visible = 0;
      items.forEach(function (item) {
        var match = !q || (item.dataset.name || '').indexOf(q) !== -1;
        item.hidden = !match;
        if (match) visible++;
      });
      if (empty) empty.hidden = visible > 0;
    });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-tabbed-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── Recommendations loader ── */
    document.querySelectorAll('.pf-tc[data-product-id]').forEach(function (el) {
      var productId  = el.dataset.productId;
      var sectionId  = el.dataset.sectionId;
      var intent     = el.dataset.intent || 'related';
      var limit      = el.dataset.limit  || 10;

      if (!productId || !sectionId) return;

      var url = '/recommendations/products?section_id=' + sectionId
              + '&product_id=' + productId
              + '&limit=' + limit
              + '&intent=' + intent;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc  = new DOMParser().parseFromString(html, 'text/html');
          var src  = doc.getElementById('pf-tc-recs-' + sectionId);
          var dest = document.getElementById('pf-tc-scroll-tab1-' + sectionId);
          if (!src || !dest) return;

          dest.innerHTML = src.innerHTML;
          pfTcArrows(sectionId, 'tab1', dest);
        })
        .catch(function () {});
    });

    /* ── Tab switching ── */
    window.pfTcSwitch = function (btn, sectionId, tabId) {
      var container = document.getElementById('pf-tc-' + sectionId);
      if (!container) return;

      container.querySelectorAll('.pf-tc-tab').forEach(function (t) { t.classList.remove('active'); });
      container.querySelectorAll('.pf-tc-panel').forEach(function (p) { p.classList.remove('active'); });

      btn.classList.add('active');
      var panel = document.getElementById('pf-tc-panel-' + tabId + '-' + sectionId);
      if (panel) {
        panel.classList.add('active');
        var scroll = panel.querySelector('.pf-tc-scroll');
        if (scroll) pfTcArrows(sectionId, tabId, scroll);
      }
    };

    /* ── Arrow visibility ── */
    window.pfTcArrows = function (sectionId, tabId, scrollEl) {
      var panel = document.getElementById('pf-tc-panel-' + tabId + '-' + sectionId);
      if (!panel) return;
      var left  = panel.querySelector('.pf-tc-arrow--left');
      var right = panel.querySelector('.pf-tc-arrow--right');
      if (!left || !right) return;

      var canLeft  = scrollEl.scrollLeft > 4;
      var canRight = scrollEl.scrollLeft + scrollEl.clientWidth < scrollEl.scrollWidth - 4;
      left.classList.toggle('visible', canLeft);
      right.classList.toggle('visible', canRight);
    };

    /* Initial arrow check for all visible panels */
    document.querySelectorAll('.pf-tc-panel.active .pf-tc-scroll').forEach(function (scroll) {
      var panel     = scroll.closest('.pf-tc-panel');
      var container = scroll.closest('.pf-tc');
      if (!panel || !container) return;
      var sectionId = container.dataset.sectionId;
      var tabId     = panel.id.replace('pf-tc-panel-', '').replace('-' + sectionId, '');
      pfTcArrows(sectionId, tabId, scroll);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.pfCtcSwitch = function (btn, sectionId, colId) {
      var container = document.getElementById('pf-ctc-' + sectionId);
      if (!container) return;

      container.querySelectorAll('.pf-ctc-tab').forEach(function (t) { t.classList.remove('active'); });
      container.querySelectorAll('.pf-ctc-panel').forEach(function (p) { p.classList.remove('active'); });

      btn.classList.add('active');
      var panel = document.getElementById('pf-ctc-panel-' + colId + '-' + sectionId);
      if (panel) {
        panel.classList.add('active');
        var scroll = panel.querySelector('.pf-ctc-scroll');
        if (scroll) pfCtcArrows(sectionId, colId, scroll);
      }
    };

    window.pfCtcArrows = function (sectionId, colId, scrollEl) {
      var panel = document.getElementById('pf-ctc-panel-' + colId + '-' + sectionId);
      if (!panel) return;
      var left  = panel.querySelector('.pf-ctc-arrow--left');
      var right = panel.querySelector('.pf-ctc-arrow--right');
      if (!left || !right) return;

      left.classList.toggle('visible',  scrollEl.scrollLeft > 4);
      right.classList.toggle('visible', scrollEl.scrollLeft + scrollEl.clientWidth < scrollEl.scrollWidth - 4);
    };

    document.querySelectorAll('.pf-ctc-panel.active .pf-ctc-scroll').forEach(function (scroll) {
      var panel     = scroll.closest('.pf-ctc-panel');
      var container = scroll.closest('.pf-ctc');
      if (!panel || !container) return;
      var sectionId = container.id.replace('pf-ctc-', '');
      var colId     = panel.id.replace('pf-ctc-panel-', '').replace('-' + sectionId, '');
      pfCtcArrows(sectionId, colId, scroll);
    });
  }());

  } catch(e) { console.error(e); }
})();
})();
